import {useMutation} from "@tanstack/react-query";
import {SalesSearchParamType} from "../interface";
import moment from "moment";
import {downloadFile} from "../../../../../util/FileDownload";
import {exportRevenueByCompanyExcel} from "../../../../../api/main/SalesApi";

export const useExportRevenueByCompanyExcel = () => {
    const {mutate} = useMutation({
        mutationFn: (data: SalesSearchParamType) => exportRevenueByCompanyExcel(data),
        onSuccess: (res, variables) => {
            if (res instanceof Blob) {
                const now = moment().format("YYYY_MM_DD_hh_mm")

                downloadFile(res, `고객사_별_매출_목록_${now}.xlsx`)
            }
        },
    });

    return {mutate};
};
